import { ThemedShared } from 'styles/themed'
import _ from 'lodash'

export const parseThemedProps = ( props ) => {
	let availableProps = {
		style: {},
		
		shadow: {},
		transparent: false,
		overflow: false,
		
		// Text
		textShadow: false,
		textLight: false,
		textHint: false,
		textPrimary: false,
		textPrimaryDark: false,
		textPrimaryLight: false,
		textSmall: false,
		textMedium: false,
		textLarge: false,
		textExtraLarge: false,
		
		// View
		smallPadding: false,
		mediumPadding: false,
		largePadding: false,
		extraLargePadding: false,
		
		negativeSmallMargin: false,
		negativeMediumMargin: false,
		negativeLargeMargin: false,
		negativeExtraLargeMargin: false,
	}
	
	// Set the props
	let themedProps = {};
	_.forEach( props, ( value, key ) => {
		if( _.has( availableProps, key ) ) {
			themedProps[ key ] = value;
		}
	})
	
	// Create the styles
	themedProps.themedStyles = stylesFromProps( themedProps );

	return themedProps
}

const stylesFromProps = ( props ) => {
	return [
		viewStylesFromProps( props ),
		textStylesFromProps( props )
	];
};

// view props
const viewStylesFromProps = ({ shadow, transparent, overflow, smallPadding, mediumPadding, largePadding, extraLargePadding, negativeSmallMargin, negativeMediumMargin, negativeLargeMargin, negativeExtraLargeMargin }) => {
	const style = [];
	
	if( !_.isEmpty( shadow ) && shadow !== false ) {
		let shadowStyle = ThemedShared.shadowed;
		
		if( _.isString( shadow ) ) {
			shadowStyle = {
				...shadowStyle,
				shadowColor: shadow
			}
		}
		
		style.push( shadowStyle );
	}
	
	if( transparent ) {
		style.push({
			backgroundColor: 'transparent'
		});
	}
	
	if( overflow === true ) {
		style.push({
			overflow: 'visible'
		});
	}
	
	switch( true ) {
		case smallPadding !== undefined:
			style.push( ThemedShared.paddingSmall );
			break;
		
		case mediumPadding !== undefined:
			style.push( ThemedShared.paddingMedium );
			break;
		
		case largePadding !== undefined:
			style.push( ThemedShared.paddingLarge );
			break;
		
		case extraLargePadding !== undefined:
			style.push( ThemedShared.paddingExtraLarge );
			break;
	}
	
	switch( true ) {
		// Negative
		case negativeSmallMargin !== undefined:
			style.push( ThemedShared.negativeMarginSmall );
			break;
		
		case negativeMediumMargin !== undefined:
			style.push( ThemedShared.negativeMarginMedium );
			break;
		
		case negativeLargeMargin !== undefined:
			style.push( ThemedShared.negativeMarginLarge );
			break;
		
		case negativeExtraLargeMargin !== undefined:
			style.push( ThemedShared.negativeMarginExtraLarge );
			break;
	}
	
	return style;
}

// text props
const textStylesFromProps = ({ textShadow, textLight, textHint, textPrimary, textPrimaryDark, textPrimaryLight, textSmall, textMedium, textLarge, textExtraLarge }) => {
	const style = [];
	
	if( textShadow ) {
		style.push( ThemedShared.textShadowed );
	}
	
	// Colors
	if( textLight ) {
		style.push( ThemedShared.textWhite );
	}
	
	if( textHint ) {
		style.push( ThemedShared.textHint );
	}
	
	if( textPrimary ) {
		style.push( ThemedShared.textPrimary );
	}
	
	if( textPrimaryDark ) {
		style.push( ThemedShared.textPrimaryDark );
	}
	
	if( textPrimaryLight ) {
		style.push( ThemedShared.textPrimaryLight );
	}
	
	switch( true ) {
		case textSmall !== undefined:
			style.push( ThemedShared.textSizeSmall );
			break;
		
		case textMedium !== undefined:
			style.push( ThemedShared.textSizeMedium );
			break;
		
		case textLarge !== undefined:
			style.push( ThemedShared.textSizeLarge );
			break;
		
		case textExtraLarge !== undefined:
			style.push( ThemedShared.textSizeExtraLarge );
			break;
	}
	
	return style;
}
